



































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import PracticeSumupDetailTab from "../../components/PracticeSumupDetailTab.vue"
import { BModal, BCarousel } from 'bootstrap-vue';
import { SumupGroup, SumupUnitAll, BunpuResult, ColKindEnum } from "../../modules/teacher/PracticeSumupDetailTotal"


export interface Data {
  sumup_group_id: string
  curriculum_id: string
  sumupGroup: SumupGroup
  sumupUnitAlls: SumupUnitAll[]
  bunpuTotalResults: BunpuResult[]
  bunpuCurriculumResults: BunpuResult[]
  total_unit_names: string[]
  curriculum_unit_names: string[]
  perFroms: number[]
  perTos: number[]
  errors: string[]
  ColKindEnum: Readonly<{ScoreRange: number; Count: number; ScoreRate: number}>
  is_exists_gender_result: boolean
}

export default defineComponent({
  components: {
    "practice-sumup-detail-tab": PracticeSumupDetailTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const modalRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sumup_group_id: null,
      curriculum_id: null,
      sumupGroup: null,
      sumupUnitAlls: [],
      bunpuTotalResults: [],
      bunpuCurriculumResults: [],
      total_unit_names: [],
      curriculum_unit_names: [],
      perFroms: [91, 81, 71, 61, 51, 41, 31, 21, 11, 0],
      perTos: [100, 90, 80, 70, 60, 50, 40, 30, 20, 10],
      errors: [],
      ColKindEnum: ColKindEnum,
      is_exists_gender_result: false,
    });

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sumup_group_id = context.root.$route.params.sumup_group_id;
      state.curriculum_id = context.root.$route.params.curriculum_id;
      await http.get(`/api/teacher/practice_sumup_detail_total?sumup_group_id=${state.sumup_group_id}`).then(response => {
        state.sumupGroup = new SumupGroup(response.data.sumup_group);
        state.sumupUnitAlls = response.data.sumup_unit_alls.map((x: any) => new SumupUnitAll(x));
        state.bunpuTotalResults = response.data.bunpu_total_results.map((x: any) => new BunpuResult(x));
        state.bunpuCurriculumResults = response.data.bunpu_curriculum_results.map((x: any) => new BunpuResult(x));        
        state.total_unit_names = state.sumupUnitAlls.filter(x => x.unit_type == Common.SumupUnitTypeEnum.MultiCurriculum || x.unit_type == Common.SumupUnitTypeEnum.MultiUnit).map(x => x.name);
        state.curriculum_unit_names = state.sumupUnitAlls.filter(x => x.unit_type == Common.SumupUnitTypeEnum.SingleCurriculum).map(x => x.name);
        state.is_exists_gender_result = response.data.is_exists_gender_result;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。`);
        }
        window.history.back();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    /************************************************************
     * ヘッダの実施日用文言生成
     ************************************************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "-";
    };

    
    return {
      ...toRefs(state),
      modalRef,
      carouselRef,
      convertExecDate,
    };
  }
});

